module.exports = __webpack_public_path__ + "img/58.b154b240.jpg";